// Known Application Error that should not be reported to Bugsnag.
export default class CustomError extends Error {
  constructor(message: string) {
    super(message)
    this.name = new.target.name
    Object.setPrototypeOf(this, new.target.prototype)
  }
}
